import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NoteService } from '../_services';
import * as NoteActions from '../_actions/note';

@Injectable({
  providedIn: 'root',
})
export class NoteEffects {
  loadNotes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.loadNotes),
      mergeMap(() =>
        this.noteService.getNotes().pipe(
          map((notes) => NoteActions.loadNotesSuccess({ notes })),
          catchError((error) => of(NoteActions.loadNotesFailure({ error })))
        )
      )
    )
  );

  addNote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.addNote),
      mergeMap(({ note }) =>
        this.noteService.saveNote(note).pipe(
          map((savedNote) => NoteActions.addNoteSuccess({ note: savedNote })),
          catchError((error) => of(NoteActions.addNoteFailure({ error })))
        )
      )
    )
  );

  updateNote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.updateNote),
      mergeMap(({ note }) =>
        this.noteService.saveNote(note).pipe(
          map((updatedNote) => NoteActions.updateNoteSuccess({ note: updatedNote })),
          catchError((error) => of(NoteActions.updateNoteFailure({ error })))
        )
      )
    )
  );

  deleteNote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.deleteNote),
      mergeMap(({ id }) =>
        this.noteService.deleteNote(id).pipe(
          map(() => NoteActions.deleteNoteSuccess({ id })),
          catchError((error) => of(NoteActions.deleteNoteFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private noteService: NoteService
  ) {}
}
